import { useContext } from 'react';
import { AxiosInstance } from 'axios';
import { AxiosIntanceContext } from 'shell/providers/http-provider';

export const useHttpProviderContext = (): AxiosInstance => {
  return useContext(AxiosIntanceContext);
};
